module.exports = __webpack_public_path__ + "assets/img/wave-bottom.svg";